import reitTooltips from '../reit/toolTipData';

export default {
  mr1: {
    id: 1,
    title: 'Nationwide',
    path: '/investment-opportunity/193744',
    status: 'status-10-open',
    statusLabel: 'Open for investment',
    REIT: true,
    imageName: 'MRI',
    propertyLocation: 'MogulREIT I',
    investmentType: 'REIT',
    investmentTypeDisplay: null,
    minimum: 5000,
    payout: 1,
    payoutLabel: 'Monthly',
    blurb: 'A Real Estate Investment Trust (\u201cREIT\u201d) designed for income and diversification through investments in debt and debt like securities.',
    payoutTooltip: reitTooltips.mr1.freq,
    lastDistributionDeclared: null,
  },
  mr2: {
    id: 3,
    title: 'Nationwide',
    path: '/investment-opportunity/274949',
    status: 'status-10-open',
    statusLabel: 'Open for investment',
    REIT: true,
    imageName: 'MRII',
    propertyLocation: 'MogulREIT II',
    investmentType: 'REIT',
    investmentTypeDisplay: null,
    minimum: 5000,
    payout: 1,
    payoutLabel: 'Quarterly',
    blurb: 'A Real Estate Investment Trust (“REIT”) designed for appreciation and income through investments in equity in multifamily apartment buildings.',
    payoutTooltip: reitTooltips.mr1.freq,
    lastDistributionDeclared: null,
  },
};
